export class StockInfo {
  constructor() {}

  lastDayTurnover: number;
  calcSharesOutstanding: number;
}
